import { useUserInfoStore } from "app/Auth/useUserInfoStore";

/**
 * Get the user info of the currently authorized user
 * @returns The user info of the currently authorized user
 */
export const useUserInfo = () => {
  const { userInfo } = useUserInfoStore();

  if (!userInfo) {
    throw new Error(
      "User not authorized - `useUserInfo` should only be used within an authorized context",
    );
  }

  return userInfo;
};
